import { message } from "antd";

const CustomMessage = ({ content = "", type = "success" }) => {
  // const renderIcon = (type: string) => {
  //   switch (type) {
  //     case "success":
  //       return (
  //         <CheckCircleOutlined
  //           style={{
  //             color: "var(--ant-success-color)",
  //             marginRight: "0",
  //             fontSize: "28px",
  //           }}
  //         />
  //       );
  //     case "error":
  //       return (
  //         <CloseCircleOutlined
  //           style={{
  //             color: "var(--ant-error-color)",
  //             marginRight: "0",
  //             fontSize: "28px",
  //           }}
  //         />
  //       );
  //     case "warning":
  //       return (
  //         <ExclamationCircleOutlined
  //           style={{
  //             color: "var(--ant-warning-color)",
  //             marginRight: "0",
  //             fontSize: "28px",
  //           }}
  //         />
  //       );
  //     default:
  //       return (
  //         <CheckCircleOutlined
  //           style={{
  //             color: "var(--ant-success-color)",
  //             marginRight: "0",
  //             fontSize: "28px",
  //           }}
  //         />
  //       );
  //   }
  // };

  // const customContent = (type: string, content?: string) => {
  //   return (
  //     <div className="custom-content">
  //       <div className="icon">{renderIcon(type)}</div>
  //       <div className="content">{content}</div>
  //     </div>
  //   );
  // };

  const getMsg = (type: string) => {
    switch (type) {
      case "success":
        return message.success({
          content: content,
        });
      case "error":
        return message.error({
          content: content,
        });
      case "warning":
        return message.warning({
          content: content,
        });
      default:
        return message.info({
          content: content,
        });
    }
  };
  // message.open({
  //   // content: customContent(type, content),
  //   // className: "custom-message",
  //   content: content,
  // });
  getMsg(type);
};

export default CustomMessage;
